import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import HotelDestinationCity from '../hero/hero-rslhome/activity/ActivityDestinationCityActivityPlace'
import HotelDestinationActivity from '../hero/hero-rslhome/activity/ActivityDestinationCityActivity'
import CircularProgress from '@mui/material/CircularProgress'

import { useDispatch, useSelector } from '../../redux/store'
import { searchActivity, searchActivityList } from '../../redux/slices/activity'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const ActivitiesRSL = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const { searchActivityRes, searchActivityListRes } = useSelector(
    state => state.activity
  )
  const [bookPickUp, setBookPickUp] = useState(null)
  const [country, setCountry] = useState(null)
  const [checkInDate, setCheckInDate] = useState('')
  const [checkOutDate, setCheckOutDate] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [cityValue1, setCityValue1] = useState([])
  const [bookDropOff, setBookDropOff] = useState(null)
  const [stateCountry, setStateCountry] = useState('')
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [searchProduct, setSearchProduct] = useState([])

  const [selectedValue, setSelectedValue] = useState({
    name: ''
  })
  const [searchProduct1, setSearchProduct1] = useState([])
  const [selectedValue1, setSelectedValue1] = useState({
    name: ''
  })
  const [pickup, setPickup] = useState({
    address: '',
    lat: 0,
    lng: 0
  })
  const [drop, setDrop] = useState({
    address: '',
    lat: 0,
    lng: 0
  })
  const [loading, setLoading] = useState(true)
  const [cityLoading, setCityLoading] = useState(false)
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isFormValid, setIsFormValid] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')

  // Add a function to check form validation

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {
    if (selectedValue?.name !== '' && selectedValue !== null) {
      if (autocompleteNext.current) {
        autocompleteNext.current.querySelector('input').focus({ preventScroll: true })
        setFocusNext(true)
      }
    }
  }, [selectedValue])

  useEffect(() => {
    setIsSubmitClicked(false)
    if (searchProduct && searchProduct.length !== 0 && searchProduct !== '') {
      setIsButtonDisabled(false)
    } else {
      setIsButtonDisabled(true)
    }
  }, [searchProduct, searchProduct1])

  const [isCalled, setIsCalled] = useState(false)


  useEffect(() => {
    setCityLoading(true)
    setLoading(true)
    setIsCalled(true)
    const timerId = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue([])
        dispatch(
          searchActivity({
            query: searchProduct.length > 0 ? searchProduct : ''
          })
        )
      } else if (searchProduct.length === 0) {
        dispatch(searchActivity({ query: '' }))
      }
    }, 500)

    const timerId1 = setTimeout(() => {
      if (searchProduct.length >= 3) {
        setCityValue1([])
        dispatch(
          searchActivityList({
            cityName: searchProduct.length > 0 ? searchProduct : ''
          })
        )
      }
    }, 500)

    return () => {
      clearTimeout(timerId1)
      clearTimeout(timerId)
    }
  }, [searchProduct])

  // useEffect(() => {
  //   setLoading(true)
  //   setCityLoading(true)
  //   const timerId = setTimeout(() => {
  //     if (searchProduct.length >= 3) {
  //       setCityValue1([])
  //       dispatch(
  //         searchActivityList({
  //           cityName: searchProduct.length > 0 ? searchProduct : ''
  //         })
  //       )
  //     }
  //   }, 500)

  //   return () => {
  //     clearTimeout(timerId)
  //   }
  // }, [searchProduct1, searchProduct])

  useEffect(() => {
    if (isCalled) {
      if (searchActivityRes !== undefined) {
        const myObjectDestination = {}
        const childArrayDestination = []
        const myObjectActivityList = {}
        const childArrayActivityList = []
        const mainArray = []
        setCityLoading(false)
        setLoading(false)



        if (searchActivityRes?.destination !== undefined) {
          if (searchActivityRes?.destination.length > 0) {
            searchActivityRes?.destination.map(data => {
              myObjectDestination.label = 'City'
              myObjectDestination.img = '/img/general/flag.png'

              childArrayDestination.push(data)
              myObjectDestination.values = childArrayDestination
            })
          } else {
            myObjectDestination.label = 'City'
            myObjectDestination.values = []
          }
        }

        if (searchActivityRes?.allCityType !== undefined) {
          if (searchActivityRes?.allCityType.length > 0) {
            searchActivityRes?.allCityType.map(data => {
              myObjectActivityList.label = data?.countryName || 'Matched Location'
              myObjectActivityList.img = '/img/general/iconnew.png'
              childArrayActivityList.push(data)
              myObjectActivityList.values = childArrayActivityList
              //
            })
          } else {
            myObjectActivityList.label = 'Matched location'
            myObjectActivityList.values = []
          }
        }

        // mainArray.push(myObjectDestination)
        mainArray.push(myObjectActivityList, myObjectDestination)

        setCityValue(mainArray)
      }
    }
  }, [searchActivityRes])

  useEffect(() => {
    if (searchActivityListRes !== undefined) {
      const myObjectDestination = {}
      const childArrayDestination = []
      const myObjectActivityList = {}
      const childArrayActivityList = []
      const mainArray = []
      setLoading(false)
      if (searchActivityListRes?.topAttraction !== undefined) {
        if (searchActivityListRes?.topAttraction.length > 0) {
          searchActivityListRes?.topAttraction.map(data => {
            myObjectDestination.label = 'Top Attraction'
            myObjectDestination.img = '/img/general/flag.png'

            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
          })
        } else {
          myObjectDestination.label = 'Top Attraction'
          myObjectDestination.values = []
        }
      }

      if (searchActivityListRes?.activityList !== undefined) {
        if (searchActivityListRes?.activityList.length > 0) {
          searchActivityListRes?.activityList.map(data => {
            myObjectActivityList.label = 'Activities'
            myObjectActivityList.img = '/img/general/iconnew.png'
            childArrayActivityList.push(data)
            myObjectActivityList.values = childArrayActivityList
            //
          })
        } else {
          myObjectActivityList.label = 'Activities'
          myObjectActivityList.values = []
        }
      }

      if (searchActivityListRes.activityList.length === 0) {
        setSelectedValue1({
          name: ''
        })
      }

      mainArray.push(myObjectDestination, myObjectActivityList)

      setCityValue1(mainArray)
    }
  }, [searchActivityListRes])

  // use

  const handleBookPickUpChange = e => {
    setBookPickUp(e.target.value)
  }

  const handleCountryChange = e => {
    setCountry(e.target.value)
  }

  const handleBookDropOffChange = selectedDropOffBook => {
    setBookDropOff(selectedDropOffBook)
  }

  // const validateForm = () => {
  //   if (selectedValue?.name !== "" && selectedValue !== null) {

  //     setIsFormValid(true);
  //     setErrorMessage('');
  //   } else {
  //     setIsFormValid(false);
  //     setErrorMessage('Please fill in all fields.');
  //   }
  // };

  const handleBooking = () => {
    setIsSubmitClicked(true)
    if (selectedValue?.name !== '' && selectedValue !== null) {
      setLoader(true)

      setErrorMessage('')

      router.push({
        pathname: '/activities/activities',
        query: {
          cityName: selectedValue?.cityName,
          name: selectedValue1?.name,
          destinationName: selectedValue?.name,
          productId: selectedValue1?._id
        }
      })
    } else {
      setIsFormValid(false)
      setErrorMessage('Please fill in all fields.')
    }
  }

  const handleBookingSearch = () => {
    setLoaderSearch(true)
    router.push({
      pathname: '/activities/activities',
      query: {
        cityName: cityValue,
        checkIn: checkInDate,
        checkOut: checkOutDate
      }
    })
  }

  return (
    <div className='activites_rsl y-gap-10'>
      <div className='activites_input'>

        <div className='Activities Activities-new py-5'>
          <HotelDestinationCity
            setCityValue={setCityValue}
            cityValue={cityValue}
            searchProduct={searchProduct}
            setSearchProduct={setSearchProduct}
            setSelectedValue={setSelectedValue}
            selectedValue={selectedValue}
            label='Select your City'
            placeholder='Search'
            setLoading={setCityLoading}
            loading={cityLoading}
            autocompleteFirst={autocompleteFirst}
            error={isSubmitClicked && selectedValue?.name === '' ? true : false}
            helperText={
              isSubmitClicked && selectedValue?.name === '' ? 'Required' : ''
            }
          />
          <HotelDestinationActivity
            autocompleteNext={autocompleteNext}
            focusNext={focusNext}
            setCityValue={setCityValue1}
            cityValue={cityValue1}
            searchProduct={searchProduct1}
            setSearchProduct={setSearchProduct1}
            setSelectedValue={setSelectedValue1}
            selectedValue={selectedValue1}
            label='Attraction & Tours'
            placeholder='Search'
            setLoading={setLoading}
            loading={loading}
          />
          <div className='trip-booking__btn'>
            <ThemeProvider theme={customTheme}>
              <button
                className='mainSearch__submit btn-1 button -dark-4 py-10 px-15 bg-dark-3 text-white w-100'
                onClick={handleBooking}
              >
                {loader ? <CircularProgress /> : 'Search'}
              </button>
            </ThemeProvider>
          </div>
        </div>

        <div className='Activities'>
          <div></div>
        </div>
      </div>
    </div>
    // </div>
  )
}

export default ActivitiesRSL
